module.exports = __webpack_public_path__ + "static/media/edit.a473b18b.svg";